// Data Transfer Rate units with conversion factors to bit/second (bps)
export const dataTransferUnits = [
  { id: 'bit-per-second', name: 'Bit/Second', symbol: 'bps', plural: 'Bits/Second', factor: 1 },
  { id: 'kilobit-per-second', name: 'Kilobit/Second', symbol: 'Kbps', plural: 'Kilobits/Second', factor: 1e3 },
  { id: 'megabit-per-second', name: 'Megabit/Second', symbol: 'Mbps', plural: 'Megabits/Second', factor: 1e6 },
  { id: 'gigabit-per-second', name: 'Gigabit/Second', symbol: 'Gbps', plural: 'Gigabits/Second', factor: 1e9 },
  { id: 'terabit-per-second', name: 'Terabit/Second', symbol: 'Tbps', plural: 'Terabits/Second', factor: 1e12 },
  { id: 'byte-per-second', name: 'Byte/Second', symbol: 'B/s', plural: 'Bytes/Second', factor: 8 },
  { id: 'kilobyte-per-second', name: 'Kilobyte/Second', symbol: 'KB/s', plural: 'Kilobytes/Second', factor: 8e3 },
  { id: 'megabyte-per-second', name: 'Megabyte/Second', symbol: 'MB/s', plural: 'Megabytes/Second', factor: 8e6 },
  { id: 'gigabyte-per-second', name: 'Gigabyte/Second', symbol: 'GB/s', plural: 'Gigabytes/Second', factor: 8e9 },
  { id: 'terabyte-per-second', name: 'Terabyte/Second', symbol: 'TB/s', plural: 'Terabytes/Second', factor: 8e12 },
  { id: 'kibibit-per-second', name: 'Kibibit/Second', symbol: 'Kibps', plural: 'Kibibits/Second', factor: 1024 },
  { id: 'mebibit-per-second', name: 'Mebibit/Second', symbol: 'Mibps', plural: 'Mebibits/Second', factor: 1048576 },
  { id: 'gibibit-per-second', name: 'Gibibit/Second', symbol: 'Gibps', plural: 'Gibibits/Second', factor: 1073741824 },
  { id: 'kibibyte-per-second', name: 'Kibibyte/Second', symbol: 'KiB/s', plural: 'Kibibytes/Second', factor: 8192 },
  { id: 'mebibyte-per-second', name: 'Mebibyte/Second', symbol: 'MiB/s', plural: 'Mebibytes/Second', factor: 8388608 },
  { id: 'gibibyte-per-second', name: 'Gibibyte/Second', symbol: 'GiB/s', plural: 'Gibibytes/Second', factor: 8589934592 },
];

export const popularDataTransferConversions = [
  { from: 'megabit-per-second', to: 'megabyte-per-second' },
  { from: 'megabyte-per-second', to: 'megabit-per-second' },
  { from: 'gigabit-per-second', to: 'megabit-per-second' },
  { from: 'megabit-per-second', to: 'kilobit-per-second' },
  { from: 'gigabyte-per-second', to: 'megabyte-per-second' },
  { from: 'kilobyte-per-second', to: 'kilobit-per-second' },
];

export const getUnitById = (id) => dataTransferUnits.find(unit => unit.id === id);

export const convertDataTransfer = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert data transfer rates and learn the conversion formula.`;
};
